import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomKeywordsCircular = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12m9.933-5.388a3.53 3.53 0 0 1 1.25 4.48l3.476 3.478a1.18 1.18 0 0 1 0 1.665 1.18 1.18 0 0 1-1.665 0l-.833.833a1.18 1.18 0 0 1-1.666 0 1.18 1.18 0 0 1 0-1.666l.833-.832-1.811-1.812a3.53 3.53 0 0 1-4.02-.687 3.537 3.537 0 0 1 .6-5.48 3.52 3.52 0 0 1 3.836.02Zm-2.77 2.127a1.18 1.18 0 0 0 0 1.666 1.18 1.18 0 0 0 1.666 0 1.18 1.18 0 0 0 0-1.665 1.18 1.18 0 0 0-1.665 0Z"
  />,
  'CustomKeywordsCircular',
);

export default CustomKeywordsCircular;
